import { type EditAuditFormBackgroundData } from './types';

export const emptyFormData = Object.freeze({
  general: {
    address: {},
    occupants: {},
    isYearBuiltApproximate: false,
    operationSchedule: [
      { weekDay: 0, isUnavailable: true },
      { weekDay: 1, isUnavailable: true },
      { weekDay: 2, isUnavailable: true },
      { weekDay: 3, isUnavailable: true },
      { weekDay: 4, isUnavailable: true },
      { weekDay: 5, isUnavailable: true },
      { weekDay: 6, isUnavailable: true },
    ],
  },
  envelope: {
    windowTypes: [],
    doorTypes: [],
    wallTypes: [],
    roofingTypes: [],
  },
  mainBreaker: {},
  controls: {},
  spaceHeating: {},
  spaceCooling: {},
  ventilation: {},
  domesticColdWater: {},
  domesticHotWater: {},
  lighting: {},
  buildingAndSystems: {},
  other: {},
} satisfies EditAuditFormBackgroundData);
